module.exports = __webpack_public_path__ + "static/media/flag-alt.c9f4d603.svg";